
<template>
  <div class="container-fluid" style="position:relative;height:500px">
    <table style="height:100%;width:100%; border:dashed 1px black;">
      <tr>
        <td>
          <div v-for="tab in tabs" class="panel-item p-0 m-0" style="position: absolute; display: none; height: 100%; z-index: 1001; padding-left:3px !important; right:0px;">
            <div class="panel-item" v-bind:class="{'expanded': tab == activeTab}" style="position:absolute;z-index: 1001;">

            </div>
            <slot name="slot1" scope="childDataScope"></slot>
            <slot name="slot2" scope="childDataScope"></slot>

          </div>
        </td>
        <td style="position:relative;">
          <div id="tabcontainer1" v-bind:style="getTabStyle2">
            <table id="tabcontainer1Table">
              <tr>
                <td v-for="tab in tabs"><a href="#" @click="selectTab(tab)">{{tab.name}}</a></td>
              </tr>
            </table>
            </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
	export default {
    name: 'vertical-tabs',
		components: {
    },
    data() {
      return {
        tabs: [{ name: 'tab 1', slotname: 'test1' }, { name: 'tab 2', slotname: 'test2' }],
        activeTab: null,
      };
    },
    props: [

    ],
    methods: {
      selectTab(tab) {
        this.activeTab = tab;
      },
      getTabStyle() {
        var width = $("#tabcontainer1Table").width();
        if (width == 0)
          return "bottom:0px";
        return "bottom:" + (width/2) + "px"
      }
    },
    created() {
      
    },
    mounted() {
      setTimeout(function () {
        
      }, 10000)
      
    },
    computed: {
      getTabStyle2: {
        get() {
          return "bottom:50px;"
        }
      }
    }
}
</script>

<style scoped>


  .panel-item.expanded {
    /*transition: right 1.2s ease-out !important;*/
    animation: fadeInRightCustom 0.7s ease-out;
  }

  @keyframes fadeInRightCustom {
    from {
      opacity: 0;
      transform: translateX(100%);
    }

    to {
      opacity: 1;
      transform: translateX(0%);
    }
  }

  #tabcontainer1 {
    position:absolute;
    display:inline-table;
    right:0px;
    transform: rotate(90deg);
  }

  .tab-item{
    display:inline-table;
    margin:auto;
    overflow:visible;
  }

</style>



// WEBPACK FOOTER //
// src/components/containers/vertical-tabs.vue